<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div
    :class="color"
    class="pa-1 px-3  lighten-3 rounded-pill text-no-wrap"
    style="width: fit-content"
  >
    {{ price | priceDisplay }}
  </div>
</template>

<script>
export default {
  name: 'PriceTableDisplay',
  props: {
    price: {},
    color: {
      type: String,
      default: 'green'
    }
  }
}
</script>

<style scoped>

</style>
